import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    inquiryType: 'general'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/messages`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert('Thank you for your message! We will get back to you within 24 hours.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
          inquiryType: 'general'
        });
      } else {
        alert('Sorry, there was an error sending your message. Please try again.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Sorry, there was an error sending your message. Please try again.');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div style={{ padding: '2rem 0' }}>
      <div className="container">
        <h1 style={{ marginBottom: '2rem' }}>Contact Us</h1>
        
        {/* Contact Info Cards */}
        <div className="grid grid-3" style={{ marginBottom: '3rem' }}>
          <div className="card" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📞</div>
            <h3>Phone</h3>
            <div style={{ flex: '1' }}>
              <p>
                <strong>Phone:</strong> +65 98592974<br/>
                <strong>WhatsApp:</strong> +65 98592974
              </p>
            </div>
            <a href="https://wa.me/6598592974" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ marginTop: 'auto', textDecoration: 'none', display: 'block', textAlign: 'center' }}>
              📱 WhatsApp Us
            </a>
          </div>

          <div className="card" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✉️</div>
            <h3>Email</h3>
            <div style={{ flex: '1' }}>
              <p>
                <strong>General:</strong> startidbits@gmail.com
              </p>
            </div>
            <a href="mailto:startidbits@gmail.com" className="btn btn-primary" style={{ marginTop: 'auto', textDecoration: 'none', display: 'block', textAlign: 'center' }}>
              📧 Send Email
            </a>
          </div>

          <div className="card" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📍</div>
            <h3>Visit Us</h3>
            <div style={{ flex: '1' }}>
              <p>
                No.1 Bukit Batok Crescent<br/>
                #04-13 Wcega Plaza<br/>
                Singapore 658064<br/>
                <strong>Mon-Fri:</strong> 8AM-5PM<br/>
                <strong>Sat:</strong> 8AM-3PM
              </p>
            </div>
            <a href="https://maps.google.com/?q=No.1+Bukit+Batok+Crescent+%2304-13+Wcega+Plaza+Singapore+658064" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ marginTop: 'auto', textDecoration: 'none', display: 'block', textAlign: 'center' }}>
              🗺️ Get Directions
            </a>
          </div>
        </div>

        {/* Quick Actions - BLOCKED */}
        {/* <div style={{ backgroundColor: 'var(--primary-saffron)', color: 'var(--white)', padding: '2rem', borderRadius: '12px', marginBottom: '3rem' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Quick Actions</h2>
          <div className="grid grid-2">
            <div style={{ textAlign: 'center' }}>
              <h3>🏢 Wholesale Customers</h3>
              <p>Need a quote or want to place a bulk order?</p>
              <button className="btn" style={{ backgroundColor: 'var(--white)', color: 'var(--primary-saffron)', marginTop: '1rem' }}>
                Get Wholesale Quote
              </button>
            </div>
            <div style={{ textAlign: 'center' }}>
              <h3>🛒 Retail Customers</h3>
              <p>Looking for a store near you that stocks our products?</p>
              <button className="btn" style={{ backgroundColor: 'var(--white)', color: 'var(--primary-saffron)', marginTop: '1rem' }}>
                Find Stockist
              </button>
            </div>
          </div>
        </div> */}

        {/* Contact Form */}
        <div className="grid grid-2" style={{ gap: '3rem' }}>
          <div className="card">
            <h3 style={{ fontWeight: 'bold' }}>Send us a message</h3>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                  Inquiry Type
                </label>
                <select
                  name="inquiryType"
                  value={formData.inquiryType}
                  onChange={handleChange}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd' }}
                >
                  <option value="general">General Inquiry</option>
                  <option value="quality">Quality/Feedback</option>
                </select>
              </div>

              <div className="grid grid-2" style={{ gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                    Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{ width: '100%', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                    Phone
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd' }}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                  Subject *
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '1rem' }}>
                Send Message
              </button>
            </form>
          </div>

          <div>
            {/* Business Hours */}
            <div className="card" style={{ marginBottom: '2rem' }}>
              <h3>Business Hours</h3>
              <div style={{ marginTop: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span>Monday - Friday</span>
                  <span style={{ fontWeight: '600' }}>8:00 AM - 5:00 PM</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span>Saturday</span>
                  <span style={{ fontWeight: '600' }}>8:00 AM - 3:00 PM</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span>Sunday</span>
                  <span style={{ color: 'var(--primary-saffron)', fontWeight: '600' }}>Closed</span>
                </div>
              </div>
              <p style={{ marginTop: '1rem', fontSize: '0.875rem', color: 'var(--accent-green)' }}>
                ⚡ Same-day response for urgent wholesale inquiries
              </p>
            </div>

            {/* FAQ */}
            <div className="card">
              <h3>Frequently Asked</h3>
              <div style={{ marginTop: '1rem' }}>
                <div style={{ marginBottom: '1rem' }}>
                  <strong>Q: What's your minimum order for wholesale?</strong>
                  <p style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>A: MOQ varies by product, typically 25-100 units. See our wholesale page for details.</p>
                </div>
                <div style={{ marginBottom: '1rem' }}>
                  <strong>Q: Do you deliver islandwide?</strong>
                  <p style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>A: Yes, free delivery for orders above S$200. Same-day delivery available.</p>
                </div>
                <div>
                  <strong>Q: Can I visit your facility?</strong>
                  <p style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>A: Yes! Please call ahead to schedule a visit during business hours.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;